import * as React from 'react';
import { useChatBoxClient } from '@/hooks';
import { ChatMessagesProps } from '@/interfaces';
import { BaseChatMessageList } from './BaseChatMessageList';

interface ChatAIMessageListProps {
	containerRef?: any;
	className?: string;
	messages: ChatMessagesProps[];
	streamingMessageId?: string | null;
	currentBotMessage?: string;
	isLoading?: boolean;
	applicationId?: number;
	conversationId?: string;
	caseId?: string;
	hideHeaderDate?: boolean;
}

export const ChatAIMessageList: React.FC<ChatAIMessageListProps> = (props) => {
	const { addChatMessages, threadId, user } = useChatBoxClient();

	return (
		<BaseChatMessageList
			{...props}
			addChatMessages={addChatMessages}
			date={''}
			threadId={threadId}
			user={user}
			showAvatarAndName={true}
			showTimestampCondition={(_item, isStreaming) => !isStreaming}
			streamingLoaderBgClass="bg-grey-10"
		/>
	);
};
